import { SentNewsFactory } from './sentNewsFactory';

import type {
  SentNewsEntity,
  SentNewsJsonPub,
  SentNewsJsonPvt,
  SentNewsPropsPub,
  SentNewsPropsPvt,
} from './sentNewsEntity';
import type { SentNewsIRepository } from './sentNewsIRepository';
import type { EntityDataPubType } from '@/infra/appsync';

import { AppsyncRepository } from '@/domain/appsyncRepository';
import {
  EntityName,
} from '@/infra/appsync';

export class SentNewsRepository extends AppsyncRepository<
  SentNewsEntity,
  SentNewsPropsPvt,
  SentNewsJsonPvt,
  SentNewsPropsPub,
  SentNewsJsonPub
> implements SentNewsIRepository {
  private factory = new SentNewsFactory();

  protected get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoAppNewsSentNewsEntity;
    return name;
  }

  /**
   * DBデータをEntityに変換
   * @param props DBデータ
   * @returns Entity
   */
  protected createFromEntityType = (
    props: EntityDataPubType,
  ) => this.factory.createFromEntityType(props);
}
